import { render, staticRenderFns } from "./CatalogBaseAccessControl.vue?vue&type=template&id=6acbf3a1&scoped=true&"
import script from "./CatalogBaseAccessControl.vue?vue&type=script&lang=js&"
export * from "./CatalogBaseAccessControl.vue?vue&type=script&lang=js&"
import style0 from "./CatalogBaseAccessControl.vue?vue&type=style&index=0&id=6acbf3a1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acbf3a1",
  null
  
)

export default component.exports
import {QCard,QCardSection,QList,QBtnToggle,QToggle,QCheckbox,QBtn,QTooltip,QItemLabel,QOptionGroup,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QList,QBtnToggle,QToggle,QCheckbox,QBtn,QTooltip,QItemLabel,QOptionGroup,QInnerLoading,QSpinnerGears}, component.options.components || {})
